import { useState, useEffect } from 'react';

export default function Countdown({ addedAt, expiresAt }) {
  const totalMs       = expiresAt - addedAt;
  const getRemaining  = () => Math.max(0, expiresAt - Date.now());

  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = setInterval(() => setRemaining(getRemaining()), 1000);
    return () => clearInterval(id);
  }); // eslint-disable-line react-hooks/exhaustive-deps

  const days  = Math.floor(remaining / (24 * 60 * 60 * 1000));
  const hours = Math.floor((remaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const mins  = Math.floor((remaining % (60 * 60 * 1000)) / 60_000);
  const secs  = Math.floor((remaining % 60_000) / 1000);

  const progress = totalMs > 0 ? 1 - remaining / totalMs : 1;
  const pct      = Math.min(100, Math.round(progress * 100));

  // Terracotta → forest green as time passes
  const hue      = Math.round(22 + progress * 129);
  const sat      = Math.round(63 - progress * 22);
  const lit      = Math.round(47 - progress * 10);
  const barColor = `hsl(${hue}, ${sat}%, ${lit}%)`;

  return (
    <div className="countdown">
      <div className="countdown-bar-wrap">
        <div className="countdown-bar" style={{ width: `${pct}%`, background: barColor }} />
      </div>
      <span className="countdown-label" style={{ color: barColor }}>
        {days > 0  ? `${days}d ${hours}h left`
         : hours > 0 ? `${hours}h ${mins}m left`
         : `${mins}m ${secs}s left`}
      </span>
    </div>
  );
}
